import AccessTimeRoundedIcon from "@mui/icons-material/AccessTimeRounded"
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline"
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded"
import KeyboardArrowUpRoundedIcon from "@mui/icons-material/KeyboardArrowUpRounded"
import {
    Box,
    IconButton,
    Stack,
    Step,
    StepContent,
    StepLabel,
    Stepper,
    Typography,
} from "@mui/material"
import { ReactElement, ReactNode, useState } from "react"

import { useScreenSize } from "../../hooks/useScreenSize"

type Steps = {
    labelBold: string
    labelFeint: string
    description: ReactNode
}

type TimelineProps = {
    applicationSteps: Steps[]
}

const ApplicationTimeline = ({
    applicationSteps,
}: TimelineProps): ReactElement => {
    const { isMob } = useScreenSize()
    const [activeStep, setActiveStep] = useState(0)

    const handleNext = (): void => {
        setActiveStep((prevActiveStep: number) => prevActiveStep + 1)
    }

    const handleBack = (): void => {
        setActiveStep((prevActiveStep: number) => prevActiveStep - 1)
    }

    return (
        <Stack>
            <Stepper activeStep={activeStep} orientation="vertical">
                {applicationSteps.map((step, index) => (
                    <Step key={step.labelFeint}>
                        {}
                        <StepLabel
                            icon={
                                index === 0 ? (
                                    <CheckCircleOutlineIcon />
                                ) : (
                                    <AccessTimeRoundedIcon />
                                )
                            }
                        >
                            <Stack direction="row" spacing={1}>
                                <Typography fontWeight="bold">
                                    {step.labelBold}
                                </Typography>

                                {!isMob && (
                                    <>
                                        <Typography color="text.secondary">
                                            {" \u2022 "}
                                        </Typography>
                                        <Typography color="text.secondary">
                                            {step.labelFeint}
                                        </Typography>
                                    </>
                                )}
                            </Stack>
                        </StepLabel>

                        <StepContent>
                            <Typography component="div">
                                {step.description}
                            </Typography>
                            <Box>
                                <div>
                                    <IconButton
                                        disabled={index === 0}
                                        onClick={handleBack}
                                        sx={{
                                            mt: 1,
                                            mr: 1,
                                        }}
                                    >
                                        <KeyboardArrowUpRoundedIcon />
                                    </IconButton>
                                    <IconButton
                                        disabled={
                                            index ===
                                            applicationSteps.length - 1
                                        }
                                        onClick={handleNext}
                                        sx={{
                                            mt: 1,
                                            mr: 1,
                                        }}
                                    >
                                        <KeyboardArrowDownRoundedIcon />
                                    </IconButton>
                                </div>
                            </Box>
                        </StepContent>
                    </Step>
                ))}
            </Stepper>
        </Stack>
    )
}

export default ApplicationTimeline
